import { LabeledSwitch } from '@components/switch';
import { useScopedTranslate } from '@locale/translate';

import { useFormBuilderContext } from './context';
import { StateField } from './state';

type Props = {
  field: Extract<StateField, { isRequired: boolean }>;
};

export const RequiredSwitch = ({ field }: Props) => {
  const actions = useFormBuilderContext().store.actions;
  const { t } = useScopedTranslate(locale);

  return (
    <LabeledSwitch
      isDisabled={field.builderProps?.canEditRequired === false}
      label={t('label')}
      onText={t('core.yes')}
      offText={t('core.no')}
      onChange={actions.createChangeHandler(field, 'isRequired')}
      value={field.isRequired}
    />
  );
};

const locale = {
  en: {
    label: 'Required',
  },
};
